import { useEffect, useState } from "react"
import { getRecyclingTypes } from "../api"

const useRecyclingTypeOptions = () => {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)

  const load = async () => {
    try {
      setLoading(true)

      const data = await getRecyclingTypes()
      setData(data.map(({ id, title }) => ({ value: id, label: title })))
    } catch (e) {
      // произошла ошибка при загрузке
      setError(true)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    load()
  }, [])

  return { data, loading, error }
}

export default useRecyclingTypeOptions
